// extracted by mini-css-extract-plugin
export var brand = "_au-9";
export var compact = "_au-6";
export var extraSmall = "_au-7";
export var icon = "_au-0";
export var large = "_au-4";
export var light = "_au-1";
export var medium = "_au-5";
export var outline = "_au-b";
export var primaryDark = "_au-a";
export var primaryLight = "_au-8";
export var primaryModern = "_au-c";
export var success = "_au-2";
export var successSolid = "_au-3";